/* eslint-disable max-statements */
window.aContentBlock = (function() {
  'use strict';
  var acbBlocks = document.getElementsByClassName('js-acb'),
      viewWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0),
      breakpoint = 768,
      breakpointMin = 576,
      breakpointMax = 940;

    function addDrag(element) {
      if (!element.classList.contains('acb--slide') &&
          !element.classList.contains('acb--slide-small')) {
            return false;
          }
      let imgs = element.querySelectorAll('img');

      // eslint-disable-next-line space-before-blocks
      imgs.forEach(function(img){
        img.setAttribute('draggable', 'false');
      });
      element.pos = {
        top: 0,
        left: 0,
        x: 0,
        y: 0
      };

      element.mouseDownHandler = function(e) {
        // Change the cursor and prevent user from selecting the text
        element.classList.remove('is-grab')
        element.classList.add('is-grabbing')
        element.pos = {
            left: element.scrollLeft,
            x: e.clientX
        };

        element.addEventListener('mousemove', element.mouseMoveHandler);
        element.addEventListener('mouseup', element.mouseUpHandler);
      };

      element.mouseUpHandler = function() {
        element.removeEventListener('mousemove', element.mouseMoveHandler);
        element.removeEventListener('mouseup', element.mouseUpHandler);
        element.classList.remove('is-grabbing');
        element.classList.add('is-grab');
      };

      element.mouseMoveHandler = function(e) {
        // How far the mouse has been moved
        const dx = e.clientX - element.pos.x;

        // Scroll the element
        element.scrollLeft = element.pos.left - dx;
      };

      element.addEventListener('mousedown', element.mouseDownHandler);
    }

    function addControlsBlock(element) {
      if (element.classList.contains('acb--inf')) {
        let prnt = element.parentNode,
            ctrl = document.createElement('div'),
            prev = document.createElement('button'),
            next = document.createElement('button'),
            prevIcon = document.createElement('div'),
            nextIcon = document.createElement('div');

        ctrl.classList.add('acb__controls');
        prev.classList.add('acb__prev');
        prev.classList.add('js-prev');
        prev.setAttribute('aria-label', 'Vorige')
        next.classList.add('acb__next');
        next.classList.add('js-next');
        next.setAttribute('aria-label', 'Volgende')
        prevIcon.classList.add('ial-fu_025');
        nextIcon.classList.add('ial-fu_026');
        prev.addEventListener('mouseup', () => {
          let cardWidth = element.getElementsByClassName('acb__item')[0].clientWidth,
              oldPos = element.scrollLeft;

          element.scroll({
            left: oldPos - cardWidth - 20,
            behavior: 'smooth'
          });
        });
        next.addEventListener('mouseup', () => {
          let cardWidth = element.getElementsByClassName('acb__item')[0].clientWidth,
              oldPos = element.scrollLeft;

          element.scroll({
            left: oldPos + cardWidth + 20,
            behavior: 'smooth'
          });
        });
        prev.appendChild(prevIcon);
        next.appendChild(nextIcon);
        ctrl.appendChild(prev);
        ctrl.appendChild(next);
        prnt.appendChild(ctrl);
      }
    }

    function addCtaBlock(element) {
      if (element.classList.contains('acb--has-cta')) {
        let prnt = element.parentNode,
            cta = prnt.querySelector('.cta__block').cloneNode(true),
            cntr = element.getElementsByClassName('acb__container')[0];

        cntr.appendChild(cta);
      }
    }

    function addControls(sliderParentContainer) {
      if (sliderParentContainer.classList.contains('acb--inf')) {
        addControlsBlock(sliderParentContainer);
      }
    }

    function addCta() {
      Array.prototype.forEach.call(acbBlocks, function(element) {
        addCtaBlock(element);
      });
    }

    function addDotsBlock(element) {
      if (element.classList.contains('js-dots')) {
        let dotsBlock = document.createElement('div'),
            dotContainer = document.createElement('ul'),
            acbItems = element.getElementsByClassName('acb__item');

        dotsBlock.classList.add('acb__dots');
        dotsBlock.classList.add('js-dots');

        dotContainer.classList.add('dots__container');
        dotContainer.setAttribute('style', '--dots-count:' + acbItems.length);

        let singleItemWidth = acbItems[0].offsetWidth + 20,
            currentIndex = Math.round(element.scrollLeft / singleItemWidth); 

        Array.prototype.forEach.call(acbItems, function(item, index) {
          let listItem = document.createElement('li'),
              dot = document.createElement('button');
        
          dot.setAttribute('aria-label', `Slide ${index + 1} van ${acbItems.length}`);
        
          dot.innerText = index + 1;
          if (index === currentIndex) {
            dot.classList.add('is-active');
            dot.setAttribute('aria-current', 'true');
          }
        
          dot.onclick = function() {
            element.scrollLeft = singleItemWidth * index;
            updateActiveDot(element, index);
          };
        
          listItem.appendChild(dot);
          dotContainer.appendChild(listItem);
        });
        
        dotsBlock.appendChild(dotContainer);
        if (element.parentNode.querySelectorAll('.acb__dots').length > 0) {
          element.parentNode.querySelectorAll('.acb__dots').forEach((olddot) => {
            element.parentNode.removeChild(olddot);
          });
        }
        element.parentNode.insertBefore(dotsBlock, element.nextSibling);

        // set up communication between the dots component and the acb component
        // maybe create eventlistener 'scroll' on acb?
        // add eventlisterer on scroll event:
        element.addEventListener('scroll', function() {
          let position = Math.round(element.scrollLeft / singleItemWidth);
          updateActiveDot(element, position);
        });
      }
    }

    function updateActiveDot(element, position) {
      let dots = element.nextSibling ? element.nextSibling.getElementsByTagName('button') : [],
          acbItems = element.getElementsByClassName('acb__item'),
          parent = element.parentNode;
  
      parent.classList.remove('on-start', 'on-end');
  
      if (position === 0) parent.classList.add('on-start');
      if (position === acbItems.length - 1) parent.classList.add('on-end');
  
      Array.prototype.forEach.call(dots, function(dot, counter) {
          dot.classList.toggle('is-active', counter === position);
          if (counter === position) {
              dot.setAttribute('aria-current', 'true');
          } else {
              dot.removeAttribute('aria-current');
          }
      });
    }

    function addDots(sliderParentContainer) {
      if (sliderParentContainer.classList.contains('js-dots')) {
        addDotsBlock(sliderParentContainer);
      }
    }

    function labelSpacer(element) {
      let rowItems = [],
          acbItems = element.getElementsByClassName('acb__item'),
          acbCols = element.style.getPropertyValue('--acb-mincols');

      if (viewWidth > breakpointMax) {
        acbCols = element.style.getPropertyValue('--acb-defcols');
      }

      Array.prototype.forEach.call(acbItems, function(item, index) {
        // skip items that contain an img (video & image)
        if (item.getElementsByClassName('acb__label').length > 0) {
          let rowIndex = Math.floor(index / Number(acbCols));

          // find all cards in this content block
          Array.prototype.forEach.call(acbItems, function(rowItem, i) {
            if (Math.floor(i / Number(acbCols)) === rowIndex) {
              rowItems.push(rowItem);
            }
          });
        }
      });
    
      // add padding to each 
      if (rowItems.length > 0) {
        rowItems.forEach(function(rowItem) {
          rowItem.style.marginTop = '1.375rem';
        });
      }
    }

    // Calculate new footer heights
    function calcFootersBlock(element) {
      let acbCols = element.style.getPropertyValue('--acb-mincols'),
          itemCounter = 0,
          itemsBuffer = [],
          acbFooterHeights = [],
          acbItems = element.getElementsByClassName('acb__item');

      if (!parseInt(acbCols)) {
        acbCols = 2;
      }

      if (viewWidth > breakpoint) {
        acbCols = element.style.getPropertyValue('--acb-defcols');
        if (!parseInt(acbCols)) {
          acbCols = 3;
        }
      }
      
      // find all cards in this content block
      Array.prototype.forEach.call(acbItems, function(item) {
        let itemFooter = item.getElementsByClassName('acb__footer')[0] || '';

        if (itemFooter === '') {
          itemsBuffer.push('');
        } else {
          itemsBuffer.push(itemFooter.offsetHeight);
        }

        // # items / # cols = # of rows
        // check footer height PER row
        itemCounter = itemCounter + 1;
        if (itemCounter === Number(acbCols)) {
          let maxHeight = Math.max(...itemsBuffer);

          itemsBuffer.forEach(function(measure) {
            // Store max height 'per' card in a row
            acbFooterHeights.push(maxHeight);
          });
          itemCounter = 0;
          itemsBuffer = [];
        }
      });
      // Proces the last row
      if (itemsBuffer.length > 0) {
        let maxHeight = Math.max(...itemsBuffer);

        itemsBuffer.forEach(function(measure) {
          acbFooterHeights.push(maxHeight);
        });
      }

      // write new heights of footer elements in every card
      acbFooterHeights.forEach(function(value, itemIndex) {
        if (acbItems[itemIndex].getElementsByClassName('acb__footer')[0]) {
          let acbFooter = acbItems[itemIndex].getElementsByClassName('acb__footer')[0];

          acbFooter.style.height = value + 'px';
        } else {
          // Card has no footer element, let's add a spacer
          let spacer = document.createElement('div');

          spacer.classList.add('acb__footer');
          spacer.setAttribute('style', 'height:' + value + 'px');
          acbItems[itemIndex].appendChild(spacer);
        }
      });
    }

    // Calculate all new footer heights
    function calcFooters() {
      // find all content blocks
      Array.prototype.forEach.call(acbBlocks, function(element) {
        calcFootersBlock(element);
        labelSpacer(element);
      });
    }

    // remove all inline heights from footers
    function clearFooters() {
      let acbItems = document.querySelectorAll('.acb__item');

      acbItems.forEach(function(item) {
        let footer = item.getElementsByClassName('acb__footer')[0];

        if (footer) {
          footer.style.removeProperty('height');
        }
      });
    }

    // Prepare slider to allow scrolling of an item to the utter-left
    function initSliderBlock(element) {
      if (element.classList.contains('acb--slide') ||
          element.classList.contains('acb--slide-small')) {
        let firstCard = element.getElementsByClassName('acb__item')[0];

        if (firstCard) {
          let cardWidth = firstCard.clientWidth,
              extraPadding = viewWidth - cardWidth - 40;
    
          element.style.setProperty('--acb-sliderPadding', extraPadding + 'px');
        }
      }
    }

    // Prepare sliders to allow scrolling of an item to the utter-left
    function initSliders(sliderParentContainer) {
      if (sliderParentContainer.classList.contains('acb--slide') ||
          sliderParentContainer.classList.contains('acb--slide-small')) {
        initSliderBlock(sliderParentContainer);
      }
    }

    // Clear inline heights and recalculate footers
    function recalcFooters() {
      viewWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

      clearFooters();
      if (viewWidth > breakpointMin) {
        calcFooters();
      }
    }

    function resetItems(element) {
      let count = element.querySelectorAll('.acb__item').length;

      if (element.classList.contains('acb--slide')) {
        element.setAttribute('style', '--acb-defcols:' + count);
      }
    }
      
    // Recalculate footer after mutation if initial state was visually-hidden combined with a display none.
    var observer = new MutationObserver(function(mutationsList) {
      for (var mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (document.body.getAttribute('data-pagename') === 'schadehulp') {
            if (!mutation.target.classList.contains('visually-hidden')) {
              recalcFooters();
            }
          }
        }
      }
  });

    // Adds observer to parent element
    function observeParentsWithClass(className) {
      var elements = document.querySelectorAll(className);
      elements.forEach(function(element) {
        observer.observe(element, { attributes: true });
      });
    }

    // Removes the generated elements from the slider
    function removeExistingSliderElements(parent) {
      parent.querySelectorAll(".acb__dots, .acb__controls").forEach(el => {
        let newEl = el.cloneNode(true);
        el.parentNode.replaceChild(newEl, el);

        newEl.remove();
      });
    }

    // Removes event listeners for dragging the slider
    function removeDragEventListeners(element) {
      if (!element) return;
      
      element.removeEventListener('mousedown', element.mouseDownHandler);
      element.removeEventListener('mousemove', element.mouseMoveHandler);
      element.removeEventListener('mouseup', element.mouseUpHandler);
      element.classList.remove('is-grab', 'is-grabbing');
    }

    // Checks the width of the acb__container compared to its parent element
    function checkSliderWidth() {
      let acbItemsContainers = Array.from(document.getElementsByClassName('acb__container'));
    
      return acbItemsContainers.map(container => {
        let parentWidth = 0,
            items = Array.from(container.getElementsByClassName('acb__item')),
            totalItemsWidth = 0;

        if (container.parentElement.classList.contains('js-carousel')) {
          // for carousel the cards overflow the parent container -> view width - left position a-content-block
          parentWidth = container.parentElement.getBoundingClientRect().width;
          // Since all items are shown in a content block --> just use width of container
          totalItemsWidth = container.offsetWidth;
        } else {
          parentWidth = container.parentElement.offsetWidth;
          totalItemsWidth = items.reduce((sum, item) => sum + item.offsetWidth, 0);
        }

        return { container, width: totalItemsWidth, parentWidth };
      });
    }

    function combineControlsAndDots() {
      Array.prototype.forEach.call(acbBlocks, function(element) {
        if (!element.classList.contains('js-carousel')) {
          return;
        }

        const controls = element.parentElement.querySelector('.acb__controls');
        const dots = element.parentElement.querySelector('.acb__dots');

        if (controls && dots) {
          const prev = controls.querySelector('.acb__prev');
          const next = controls.querySelector('.acb__next');

          if (prev) dots.appendChild(prev);
          if (next) dots.appendChild(next);

          controls.remove();
        }
      });      
    }

    // Validates which acb__container elements require slider functionality
    function validSliderContainer() {
      let allContainers = checkSliderWidth(),
          validContainers = allContainers.filter(({ width, parentWidth }) => {
            let isValid = width > parentWidth;
            return isValid;
          });

      allContainers.forEach(({ container }) => {
        let acbContainerParent = container.parentElement,
            aContentBlockParent = acbContainerParent.parentElement;
        removeExistingSliderElements(aContentBlockParent);
        removeDragEventListeners(acbContainerParent);
        
        if (!validContainers.some(({ container: validContainer }) => validContainer === container)) {
          acbContainerParent.style.removeProperty('--acb-sliderPadding');
          acbContainerParent.scrollLeft = 0; 
        }
      });

      validContainers.forEach(({ container }) => {
        let acbContainerParent = container.parentElement;

        addDots(acbContainerParent);
        addControls(acbContainerParent);
        addDrag(acbContainerParent);
        initSliders(acbContainerParent);
        combineControlsAndDots();
      });
    }

    function syncCompareItems(acbBlock) {
      // --- sync compare-row heights ---
      acbBlock.querySelectorAll('.compare-row').forEach(row => {
        row.style.minHeight = '';
      });

      const rowGroups = {};
      acbBlock.querySelectorAll('.compare-row').forEach(row => {
        const rowClass = Array.from(row.classList).find(c => c.startsWith('row-'));
        if (!rowGroups[rowClass]) {
          rowGroups[rowClass] = [];
        }
        rowGroups[rowClass].push(row);
      });

      Object.values(rowGroups).forEach(rows => {
        const maxHeight = Math.max(...rows.map(r => r.offsetHeight));
        rows.forEach(r => {
          r.style.minHeight = `${maxHeight}px`;
        });
      });

      // --- sync title/subtitle height ---
      const compareItems = [...acbBlock.querySelectorAll('.acb__item.acbi--compare, .acb__item.acbi--compare--no-lines')];
      if (!compareItems.length) return;

      const heights = compareItems.map(item => {
        const title = item.querySelector('.mcbx__title');
        const sub = item.querySelector('.mcbx__sub');
        let height = 0;

        if (title) height += title.offsetHeight;
        if (sub) height += sub.offsetHeight;

        return { item, title, sub, height };
      });

      const maxHeaderHeight = Math.max(...heights.map(h => h.height));

      heights.forEach(({ title, sub, height }) => {
        const marginBottom = maxHeaderHeight - height;

        if (sub) {
          sub.style.marginBottom = marginBottom + 'px';
        } else if (title) {
          title.style.marginBottom = marginBottom + 'px';
        }
      });
    }

    function compareListUlTransform(acbBlock) {
      const lists = acbBlock.querySelectorAll('.acb__body ul.compare-list');

      lists.forEach(list => {
        const items = Array.from(list.children);

        items.forEach((li, index) => {
          li.classList.add('compare-row', `row-${index + 1}`);
        });
      });

      syncCompareItems(acbBlock);
    }

    return {
      init: function() {

        Array.prototype.forEach.call(acbBlocks, function(block) {
          if (block.querySelector('.compare-list')) {
            compareListUlTransform(block);
          }
        });

        // Calculate Footer height
        if (viewWidth > breakpointMin) {
          calcFooters();
        }

        // Add cta to acb
        addCta();

        // Recalc on resize
        window.addEventListener('resize', recalcFooters);
        window.addEventListener('keuzehulp:redraw', recalcFooters);
        window.addEventListener('resize', validSliderContainer);
        window.addEventListener('resize', () => {
          Array.prototype.forEach.call(acbBlocks, function(block) {
            if (block.querySelectorAll('.acbi--compare, .acbi--compare--no-lines')) {
              syncCompareItems(block);
            }
          });
        });

        // Observer for schadehulp
        observeParentsWithClass('section.visually-hidden');

        validSliderContainer();
      },
      recalc: function($acbBlock) {
        resetItems($acbBlock);
        initSliderBlock($acbBlock);

        compareListUlTransform($acbBlock);

        // Calculate Footer height
        if (viewWidth > breakpointMin) {
          calcFootersBlock($acbBlock);
          calcFooters();
        }

        addDotsBlock($acbBlock);

        return $acbBlock;
      }
    };
})();

window.aContentBlock.init();
